import * as Long from "long";
import { ofType } from "redux-observable";
import { from } from "rxjs";
import { retry, switchMap } from "rxjs/operators";
import { CommandCode, } from "../../../utils/network/generated/protoTypes";
import { actionInventoryInfoRemoveResource } from "../../info/inventory/actionInventoryInfo";
import { actionPlayerInfoUpdateCoopInfo } from "../../info/player/actionPlayerInfo";
import { actionCoopInfoReceived, actionCoopMenuSetFirstTab, actionCoopMenuTabGoTo, TypeActionCoopInfo, } from "../actionCoop";
import { IdCoopCategory } from "../IdCoopCategory";
export var epicCoopFound = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionCoopInfo.FoundCoop), switchMap(function (action) {
        var state = state$.value;
        return deps
            .netSend({
            id: CommandCode.CreateCoop,
            props: {
                description: action.description,
                joinPolicy: action.joinPolicy,
                language: action.language,
                minLevel: action.minLevel,
                name: action.name,
                playerId: state.playerInfo.playerId,
            },
        })
            .pipe(switchMap(function (res) {
            var coopId = res.coop && res.coop.id ? res.coop.id : Long.ZERO;
            return from([
                actionCoopInfoReceived(res),
                actionPlayerInfoUpdateCoopInfo(coopId),
                actionInventoryInfoRemoveResource(res.cost),
                actionCoopMenuSetFirstTab(IdCoopCategory.CoopInfoView),
                actionCoopMenuTabGoTo(IdCoopCategory.CoopInfoView),
            ]);
        }), retry());
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/cooperative/epic/epicCoopFound.ts
// module id = 1801
// module chunks = 3